module.exports = __webpack_public_path__ + "files/94c21a78aa4a8d584f6e4ae554c4686f.png";